export default __webpack_public_path__ + "static/media/Orders.f6e743b4.png";